export default "__VITE_ASSET__DuYzZABt__"